import React, { useEffect, useState } from 'react';
import Loader from '@components/Loader';

import './PlaybackPreparingLoader.less';

// Loads finishing faster than this show no loader, so switching quickly
// between media does not flash it
export const DELAYED_LOADER_MS = 300;
// While the previous asset's image or video frame is still on screen
export const PREVIOUS_MEDIA_LOADER_DELAY_MS = 1000;

function PlaybackPreparingLoader({
  isVideo,
  delayed = false,
  delayMs = DELAYED_LOADER_MS
}: {
  isVideo?: boolean;
  /** Show only if still mounted after a short delay (plain loading states) */
  delayed?: boolean;
  delayMs?: number;
}) {
  const [isVisible, setIsVisible] = useState(!delayed);

  useEffect(() => {
    if (!delayed) return;
    const timeout = setTimeout(() => setIsVisible(true), delayMs);
    return () => clearTimeout(timeout);
  }, [delayed, delayMs]);

  if (!isVisible) return null;

  return (
    <div className="media_viewer_playback_container">
      <div className="media_viewer_playback_container__content">
        <Loader spinSize={72} isSpinning={true} classNameWrapper="loader" />
        <div className="copy">
          {isVideo ? 'Preparing for playback...' : 'Preparing preview...'}
        </div>
      </div>
    </div>
  );
}

export default PlaybackPreparingLoader;
